export const UPDATE_FORM = "UPDATE_FORM_INCENTIVE";
export const RESET_FORM = "RESET_FORM_INCENTIVE";

export const updateIncentiveRulesForm = (formData) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_FORM,
      payload: formData,
    });
  };
};

export const resetForm = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_FORM,
    });
  };
};
